export const headers = [
  {
    text: 'Data Criação',
    align: 'start',
    sortable: true,
    value: 'createdDate',
    width: '25%',
  },
  {
    text: 'Última Atualização',
    align: 'start',
    sortable: true,
    value: 'updatedDate',
    width: '15%'
  },
  {
    text: 'Equipamento',
    align: 'start',
    sortable: true,
    value: 'equipmentName',
    width: '15%'
  },
  {
    text: 'Detecções',
    align: 'start',
    sortable: true,
    value: 'countUpdated',
    width: '15%'
  },
  {
    text: "Mensagem",
    align: 'start',
    sortable: true,
    value: 'message',
    width: '10%'
  },
  {
    text: 'Estado',
    align: 'start',
    sortable: true,
    value: 'equipmentStateName',
    width: '10%'
  },
  {
    text: 'Versão Firmware',
    align: 'start',
    sortable: true,
    value: 'firmwareVersion',
    width: '8%'
  },
  {
    text: 'Ignição',
    align: 'start',
    sortable: true,
    value: 'ignitionStatus',
    width: '8%'
  },
  {
    text: 'Antena GPS',
    align: 'start',
    sortable: true,
    value: 'gpsAntennaStatus',
    width: '8%'
  },
  {
    text: 'Contagem Bloqueios',
    align: 'start',
    sortable: true,
    value: 'lockCount',
    width: '10%'
  },
  {
    text: 'Slaves Pareados',
    align: 'start',
    sortable: true,
    value: 'pairedSlavesCount',
    width: '10%'
  },
  {
    text: 'Horas de Operação',
    align: 'start',
    sortable: true,
    value: 'totalOperatingHours',
    width: '10%'
  },
  {
    text: 'Tempo sem GPS (s)',
    align: 'start',
    sortable: true,
    value: 'timeWithoutGpsSignalSeconds',
    width: '10%'
  },
  {
    text: 'Valor Lido (Amplificador)',
    align: 'start',
    sortable: true,
    value: 'logAmplifierValue',
    width: '10%'
  },
  {
    text: 'Potência Atual GPS',
    align: 'start',
    sortable: true,
    value: 'currentGpsPower',
    width: '10%'
  },
  {
    text: 'Tensão Interna (Regulador)',
    align: 'start',
    sortable: true,
    value: 'internalVoltageRegulator',
    width: '10%'
  },
  {
    text: 'Tensão Externa (Bateria)',
    align: 'start',
    sortable: true,
    value: 'externalVoltageBattery',
    width: '10%'
  },
  {
    text: 'Sensor 01',
    align: 'start',
    sortable: true,
    value: 'sensorOneStatus',
    width: '10%'
  },
  {
    text: 'Sensor 02',
    align: 'start',
    sortable: true,
    value: 'sensorTwoStatus',
    width: '10%'
  },
  {
    text: 'Sensor 03',
    align: 'start',
    sortable: true,
    value: 'sensorThreeStatus',
    width: '10%'
  },
  {
    text: 'Sensor 04',
    align: 'start',
    sortable: true,
    value: 'sensorFourStatus',
    width: '10%'
  },
  {
    text: 'Sensor 05',
    align: 'start',
    sortable: true,
    value: 'sensorFiveStatus',
    width: '10%'
  },
  {
    text: 'Latitude',
    align: 'start',
    sortable: true,
    value: 'latitude',
    width: '10%'
  },
  {
    text: 'Longitude',
    align: 'start',
    sortable: true,
    value: 'longitude',
    width: '10%'
  },
  {
    text: 'Ações',
    align: 'center',
    sortable: false,
    value: 'actions',
    width: '5%'
  }
]